// extracted by mini-css-extract-plugin
export var container = "_5p-0";
export var fallback = "_5p-5";
export var fallbackIcon = "_5p-6";
export var hidden = "_5p-2";
export var image = "_5p-3";
export var loaded = "_5p-4";
export var placeholder = "_5p-1";